import React from 'react'
import { useGlobalState } from 'state'
import * as api from 'common/api'
import { Coordinates, TimeSeriesRow } from 'common/types'
import { TimeSeriesSlider } from 'components/layers/TimeSeriesSlider'
import { IDs } from 'common/consts'
import dayjs from 'dayjs'
import { convertCoordinates } from 'common/utils'
import { SplitImageLayer } from './SplitImageLayer'

export const DosyaLayer = () => {
  const state = useGlobalState()
  const [sliderIndex, setSliderIndex] = React.useState(-1)
  const [sliderBaseDate, setSliderBaseDate] = React.useState<dayjs.Dayjs>(dayjs.utc())
  const [timeSeries, setTimeSeries] = React.useState<TimeSeriesRow[]>([])
  const [coordinates, setCoordinates] = React.useState<Coordinates>([])
  const [imageUrl, setImageUrl] = React.useState<string | null>(null)
  const [opacity, setOpacity] = React.useState<number>(state.map.layerOpacity['dosya'])

  const displayLabelsHours = [-3, -2, -1, 0]

  React.useEffect(() => {
    setOpacity(state.map.layerOpacity['dosya'])
  }, [state.map.layerOpacity['dosya']])

  React.useEffect(() => {
    load()
  }, [timeSeries])

  React.useEffect(() => {
    (async () => {await fetch()})()
  }, [state.app.baseDate])

  React.useEffect(() => {
    load()
  }, [sliderIndex])

  const load = async () => {
    if (timeSeries.length === 0 || sliderIndex < 0 || timeSeries.length <= sliderIndex ) {
      setImageUrl(null)
    } else {
      setImageUrl(timeSeries[sliderIndex].url)
    }
  }

  const fetch = async () => {
    const res = await api.get('/dosya', {date: state.app.getFormattedBaseDate(5)})
    if (res === null) {
      return
    }
    if (coordinates.length === 0) {
      setCoordinates(convertCoordinates(res.bounds))
    }

    const rows: any[] = res.imageInfos

    const baseDateIndex = rows.findIndex(row => row.date === res.baseDate)
    setTimeSeries(rows)
    setSliderIndex(baseDateIndex)
    setSliderBaseDate(dayjs.utc(rows[baseDateIndex].date))
  }

  const sliderMoveend = (index: number) => {
    setSliderIndex(index)
  }

  return (
    <>
      <SplitImageLayer
        url={imageUrl}
        coordinates={coordinates}
        sourceId={IDs.dosya.source}
        layerId={IDs.dosya.layer}
        opacity={opacity}
      />
      <TimeSeriesSlider
        baseDate={sliderBaseDate}
        currentIndex={sliderIndex}
        timeSeries={timeSeries}
        displayLabelsHours={displayLabelsHours}
        moveend={sliderMoveend}
      />
    </>
  )
}
